:host {
  --step-empty: 16px;
  --step-empty-border: 4px;

  align-items: center;
  background-color: transparent;
  border: 0;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  min-height: var(--step-size);
  padding: 0;
  position: relative;

  // Layout vertical
  &.vertical {
    justify-content: start;

    &[data-label="left"] {
      justify-content: end;
    }

    &[data-label="right"] {
      justify-content: start;
    }
  }

  // Labels laterais (horizontal)
  &[data-label="left"]:not(.vertical) {
    justify-content: end;
  }

  &[data-label="right"]:not(.vertical) {
    justify-content: start;
  }

  // Modo controller
  &.mode-controller {
    min-width: 20px;
    min-height: 20px;
  }

  // Desabilitar interações
  &.disabled-host {
    cursor: not-allowed;
  }
}

// ===== BOTÃO STEP (step-progress-btn) =====

.step-progress-btn {
  align-items: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  min-height: var(--step-size);
  padding: 0;
  position: relative;

  // ===== INDICADOR CIRCULAR (::before) =====
  &::before {
    align-items: center;
    background-color: var(--background);
    border: var(--step-line) solid var(--interactive);
    border-radius: 50%;
    color: var(--interactive);
    content: attr(step-num);
    display: inline-flex;
    font-size: var(--font-size-scale-up-03);
    font-weight: var(--font-weight-medium);
    height: var(--step-size);
    justify-content: center;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    width: var(--step-size);
    z-index: 2;
  }

  // ===== CONECTOR / LINHA DO TEMPO (::after) =====
  &::after {
    background-color: var(--interactive);
    content: "";
    display: block;
    height: var(--step-line);
    left: 0;
    position: absolute;
    right: 0;
    z-index: 1;
  }
}

// ===== POSIÇÃO DO LABEL (justify-content do botão) =====
:host([data-label="left"]) .step-progress-btn {
  justify-content: end;
}

:host([data-label="right"]) .step-progress-btn {
  justify-content: start;
}

:host(.vertical) .step-progress-btn {
  justify-content: start;
}

:host(.vertical[data-label="left"]) .step-progress-btn {
  justify-content: end;
}

:host(.vertical[data-label="right"]) .step-progress-btn {
  justify-content: start;
}

// ===== ÍCONE DE CONTEÚDO (step-icon) =====
.step-icon {
  align-items: center;
  color: var(--interactive);
  display: inline-flex;
  height: var(--step-size);
  justify-content: center;
  position: absolute;
  width: var(--step-size);
  z-index: 4;
}

// ===== ÍCONE DE ALERTA (step-alert) =====
.step-alert {
  align-items: center;
  border-radius: 50%;
  color: var(--color-dark);
  display: flex;
  height: var(--font-size-scale-up-04);
  justify-content: center;
  position: absolute;
  width: var(--font-size-scale-up-04);
  z-index: 4;

  &.no-content {
    width: calc(var(--font-size-scale-up-04) + var(--step-empty-border));
    height: calc(var(--font-size-scale-up-04) + var(--step-empty-border));
  }
}

// ===== POSICIONAMENTO DO INDICADOR (::before) POR LABEL =====

// Label bottom: indicador no topo
:host([data-label="bottom"]) .step-progress-btn::before {
  top: 0;
}

// Label top: indicador embaixo
:host([data-label="top"]) .step-progress-btn::before {
  bottom: 0;
}

// Label left: indicador à direita
:host([data-label="left"]) .step-progress-btn::before {
  left: auto;
  right: 0;
}

// Label right: indicador à esquerda
:host([data-label="right"]) .step-progress-btn::before {
  left: 0;
  right: auto;
}

// Vertical: indicador centralizado
:host(.vertical) .step-progress-btn::before {
  inset: 0 auto 0 50%;
  margin: auto;
  transform: translateX(-50%);
}

// Vertical + label left: indicador à direita
:host(.vertical[data-label="left"]) .step-progress-btn::before {
  left: auto;
  right: 0;
  transform: none;
}

// Vertical + label right: indicador à esquerda
:host(.vertical[data-label="right"]) .step-progress-btn::before {
  left: 0;
  right: auto;
  transform: none;
}

:host(.mode-controller) .step-progress-btn::before {
  inset: 0;
  margin: auto;
}

// ===== POSICIONAMENTO DO ÍCONE (step-icon) POR LABEL =====

:host([data-label="bottom"]) .step-icon {
  top: 0;
}

:host([data-label="top"]) .step-icon {
  bottom: 0;
}

/* Vertical layout: centralizar o ícone dentro do step-item */
:host([data-label="bottom"].vertical) .step-icon,
:host([data-label="top"].vertical) .step-icon {
  top: 0;
  bottom: 0;
  left: 50%;
  margin: auto;
  transform: translateX(-50%);
}

// ===== POSICIONAMENTO DO ALERTA (step-alert) POR LABEL =====

:host([data-label="bottom"]) .step-alert {
  transform: translate(calc(var(--step-size) * 0.5), calc(var(--step-size) * -0.75));
}

:host([data-label="top"]) .step-alert {
  transform: translate(calc(var(--step-size) * 0.5), calc(var(--step-size) * 0.25));
}

:host([data-label="left"]) .step-alert {
  transform: translate(calc(var(--step-size) * 0.4), calc(var(--step-size) * -0.25));
}

:host([data-label="right"]) .step-alert {
  transform: translate(calc(var(--step-size) * 0.65), calc(var(--step-size) * -0.25));
}

// ===== LINHAS CONECTORAS HORIZONTAIS =====

// Primeiro item: linha começa no centro
:host(:first-of-type:not(.vertical)) .step-progress-btn::after {
  left: 50%;
}

// Último item: linha termina no centro
:host(:last-of-type:not(.vertical)) .step-progress-btn::after {
  right: 50%;
}

:host([data-label="bottom"]:not(.vertical)) .step-progress-btn::after {
  top: calc(var(--step-size) * 0.5);
}

:host([data-label="top"]:not(.vertical)) .step-progress-btn::after {
  bottom: calc(var(--step-size) * 0.5);
}

:host([data-label="left"]:not(.vertical)) .step-progress-btn::after {
  left: 0;
}

:host([data-label="left"]:not(.vertical):first-of-type) .step-progress-btn::after {
  left: 100%;
}

:host([data-label="left"]:not(.vertical):last-of-type) .step-progress-btn::after {
  right: 0;
}

// Label right
:host([data-label="right"]:not(.vertical)) .step-progress-btn::after {
  right: 0;
}

:host([data-label="right"]:not(.vertical):first-of-type) .step-progress-btn::after {
  left: 0;
}

:host([data-label="right"]:not(.vertical):last-of-type) .step-progress-btn::after {
  right: 100%;
}

// ===== LINHAS CONECTORAS VERTICAIS =====
:host(.vertical) .step-progress-btn::after {
  inset: 0 auto 0 50%;
  height: auto;
  width: var(--step-line);
  margin: 0;
  transform: translateX(-50%);
}

// Vertical + label top
:host(.vertical[data-label="top"]) .step-progress-btn::after {
  top: 50%;
}

// Vertical + label bottom
:host(.vertical[data-label="bottom"]) .step-progress-btn::after {
  bottom: 50%;
}

:host(.vertical:first-of-type) .step-progress-btn::after {
  top: 50%;
}

:host(.vertical:last-of-type) .step-progress-btn::after {
  bottom: 50%;
}

:host(.vertical[data-label="left"]) .step-progress-btn::after {
  left: auto;
  right: calc(var(--step-size) * 0.5);
  margin: 0;
}

:host(.vertical[data-label="right"]) .step-progress-btn::after {
  left: calc(var(--step-size) * 0.5);
  right: auto;
  margin: 0;
}

// ===== LABEL (step-info) =====
.step-info {
  color: var(--interactive);
  display: inline-block;
  font-size: var(--font-size-scale-up-01);
  font-weight: var(--font-weight-medium);
}

// Rótulo abaixo (padrão)
:host([data-label="bottom"]) .step-info {
  margin-top: var(--step-size);
  padding-top: var(--spacing-scale-2x);
}

// Rótulo acima
:host([data-label="top"]) .step-info {
  margin-bottom: var(--step-size);
  padding-bottom: var(--spacing-scale-2x);
}

:host(.vertical[data-label="top"]) .step-info,
:host(.vertical[data-label="bottom"]) .step-info {
  display: block;
  text-align: center;
  width: 100%;
}

// Rótulo esquerda (oculto em mobile)
:host([data-label="left"]:not(.vertical)) .step-info {
  display: none;

  @include media-breakpoint-up(sm) {
    background-color: var(--background);
    display: inline-block;
    margin-right: var(--step-size);
    padding: var(--spacing-scale-2x);
    position: relative;
    z-index: 3;
  }
}

// Rótulo direita (oculto em mobile)
:host([data-label="right"]:not(.vertical)) .step-info {
  display: none;

  @include media-breakpoint-up(sm) {
    background-color: var(--background);
    display: inline-block;
    margin-left: var(--step-size);
    padding: var(--spacing-scale-2x);
    position: relative;
    z-index: 3;
  }
}

// Labels laterais sempre visíveis no layout vertical
:host(.vertical[data-label="left"]) .step-info,
:host(.vertical[data-label="right"]) .step-info {
  background-color: var(--background);
  display: inline-block;
  padding: var(--spacing-scale-2x);
  position: relative;
  z-index: 3;
}

:host(.vertical[data-label="left"]) .step-info {
  margin-right: var(--step-size);
  margin-left: 0;
}

:host(.vertical[data-label="right"]) .step-info {
  margin-left: var(--step-size);
  margin-right: 0;
}

// ===== ESTADOS =====

:host .step-progress-btn {
  // Estados de alerta (success, info, warning, danger)
  &[data-alert="success"] {
    color: var(--success);

    .step-info {
      color: var(--success);
    }

    .step-alert {
      background-color: var(--success);
    }
  }

  &[data-alert="info"] {
    color: var(--info);

    .step-info {
      color: var(--info);
    }

    .step-alert {
      background-color: var(--info);
    }
  }

  &[data-alert="warning"] {
    color: var(--color-light);

    .step-info {
      color: var(--color);
    }

    .step-alert {
      background-color: var(--warning);
    }
  }

  &[data-alert="danger"] {
    color: var(--danger);

    .step-info {
      color: var(--danger);
    }

    .step-alert {
      background-color: var(--danger);
    }
  }

  &.active {
    &::before {
      background-color: var(--active);
      border-color: var(--active);
      color: var(--background);
    }

    .step-icon {
      color: var(--background);
    }
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    &::before {
      outline: var(--focus) var(--focus-style) var(--focus-width);
      outline-offset: var(--focus-offset);
      z-index: 4;
    }
  }

  &:hover:not(:disabled) {
    &::before {
      background-image: linear-gradient(
        rgb(var(--interactive-rgb), var(--hover)),
        rgb(var(--interactive-rgb), var(--hover))
      );
    }
  }

  &:disabled {
    opacity: 1;
    cursor: not-allowed;

    &::before {
      background-color: var(--background);
      border-color: rgb(var(--interactive-rgb), var(--disabled));
      color: rgb(var(--interactive-rgb), var(--disabled));
    }

    .step-icon {
      opacity: var(--disabled);
    }

    .step-info {
      color: rgb(var(--interactive-rgb), var(--disabled));
    }
  }
}

// ===== DATA-TYPE="VOID" (NO-CONTENT) =====
:host([data-type="void"]) {
  .step-progress-btn {
    &.active {
      .step-alert {
        border: var(--step-empty-border) solid var(--active);
        height: calc(var(--font-size-scale-up-04) + var(--step-empty-border));
        width: calc(var(--font-size-scale-up-04) + var(--step-empty-border));
      }
    }

    .step-alert {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 4;
    }

    &::before {
      content: "";
      height: var(--step-empty);
      width: var(--step-empty);
      left: 50%;
      right: auto;
      margin: 0;
      transform: translate(-50%, -50%);
      top: 50%;
    }
  }

  .step-info {
    height: 0;
    overflow: hidden;
    position: absolute;
    width: 0;
  }
}

// ===== Z-INDEX HIERARCHY =====
// z-index: 1 - Conectores (linhas ::after)
// z-index: 2 - Indicadores (::before)
// z-index: 3 - Labels com background
// z-index: 4 - Highlight icons (step-alert)

// ===== ICONES E ESTILOS AUXILIARES =====
.content-type-br-icon {
  color: var(--interactive);
  font-size: var(--font-size-scale-up-01);
  font-weight: var(--font-weight-bold);
}

.step-progress-btn.active .content-type-br-icon {
  color: var(--background);
}

:host(.vertical[data-label="top"]) .step-alert,
:host(.vertical[data-label="bottom"]) .step-alert {
  top: 50%;
  left: 50%;
  transform: translate(25%, -75%);
}

:host([data-type="void"]) .step-progress-btn[data-alert].focus-visible::before,
:host([data-type="void"]) .step-progress-btn[data-alert]:focus-visible::before {
  outline: none;
}

:host([data-type="void"]) .step-progress-btn[data-alert].focus-visible .step-alert,
:host([data-type="void"]) .step-progress-btn[data-alert]:focus-visible .step-alert {
  outline: var(--focus) var(--focus-style) var(--focus-width);
  outline-offset: var(--focus-offset);
  z-index: 4;
}
